<template>
    <div class="business-orders-file">
        <svg class="business-orders-file__icon"
             width="90"
             height="90"
        >
            <use xlink:href="#file-download" />
        </svg>
        <h4 class="business-orders-file__title">
            {{ fileTitle }}
        </h4>
        <div class="business-orders-file__actions">
            <a class="business-orders-file__action"
               target="_blank"
               :href="downloadUrl"
            >
                {{ $t('general.files.download') }}
            </a>
            <div v-if="!isPreview"
                 class="business-orders-file__action-separator"
            />
            <base-button v-if="!isPreview && $hasAccess('businessorders:write')"
                         class="business-orders-file__action"
                         as-link
                         @click="handleDeleteFileClick"
            >
                {{ $t('general.delete') }}
            </base-button>
        </div>
        <modals-container v-if="isTabletSize" />
    </div>
</template>

<script>
import '@/assets/icons/file-download.svg';
import { $t } from '@/translations';
import businessOrdersApi from '@/services/resources/businessOrdersApi';
import BaseButton from '../../components/base/BaseButton';


export default {
    components: { BaseButton },
    props: {
        orderId: {
            type: Number,
            required: true,
        },
        documentId: {
            type: Number,
            required: true,
        },
        fileTitle: {
            type: String,
            default: '',
        },
        isPreview: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        downloadUrl() {
            return `${process.env.VUE_APP_API_URL}/businessOrders/${this.orderId}/documents/${this.documentId}`;
        },
        isTabletSize() {
            return this.$mq === 'tablet' || this.$mq === 'mobile';
        },
    },
    methods: {
        handleDeleteFileClick(e) {
            e.stopPropagation();
            this.openDialog();
        },
        async deleteFile() {
            const saved = await this.$monitor(
                () => businessOrdersApi.deleteDocument(this.orderId, this.documentId),
            );

            if (saved) {
                this.$toast.success($t('businessOrders.toasts.documentRemoved'));
                this.$emit('removed', this.documentId);
                this.$emit('delete', this.fileTitle);
            }
        },
        openDialog() {
            return this.$dialog.info({
                title: $t('businessOrders.documentConfirmationModal.title'),
                text: $t('businessOrders.documentConfirmationModal.text'),
                buttons: [
                    {
                        title: $t('general.cancel'),
                        handler: () => {
                            this.$dialog.close();
                        },
                    },
                    {
                        title: $t('general.delete'),
                        handler: () => {
                            this.$dialog.close();
                            this.deleteFile();
                        },
                    },
                ],
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.business-orders-file {
    $_this: &;

    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 250px;
    height: 250px;
    margin: 16px 0;
    padding: 26px 13px;
    overflow: hidden;
    border: 2px dashed $color-gray-600;
    border-radius: 2px;

    &:hover {
        #{$_this}__icon {
            transition: $transition-quick;
            color: $color-teal-700;
        }
    }

    &__icon {
        transition: $transition-quick;
        color: $color-gray-800;
    }

    &__title {
        width: 100%;
        overflow: hidden;
        color: $color-text-body;
        font-family: $font-family-primary;
        font-size: $font-size-md;
        font-weight: 500;
        text-align: center;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    &__action-separator {
        display: inline-block;
        position: relative;
        top: 5px;
        width: 1px;
        height: 80%;
        margin: auto 10px;
        background: $color-gray-200;
    }

    &__action {
        font-size: $font-size-base;
        letter-spacing: $letter-spacing-xs;
    }

    @include respond-to($media-tablet, max) {
        margin: 16px 26px;
    }
}
</style>
